// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"6f1ba5de","189":"d61d570a","349":"15e87c25","453":"3bdf626c","517":"15b0c66c","683":"899adfb3","860":"6b0ace94","950":"9a1d2de1"}[chunkId] + ".chunk.js";
};